import { Directive, OnInit, OnDestroy, inject } from '@angular/core';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';
import { NotifierEvents } from '../../../common/enums/enums';
import { IComponentBase } from './component-base-interface';

@Directive()
export abstract class ComponentBase implements OnInit, OnDestroy, IComponentBase {
  // Use inject() instead of constructor injection to break the circular dependency
  protected notifierService = inject(NotifierV2Service);

  registerOn: string = 'init';
  isDirty: boolean;
  componentName: string;
  expectedUpdates: NotifierEvents[];

  constructor() {
     this.registerImmediately(this);
  }

  public ngOnInit() {
    this.register(this);
  }

  public notify() {
  }

  public canChange(): boolean {
    return true;
  }

  public show(params: any) {
  }

  public hide() {
  }

  public register(component: IComponentBase) {
    this.notifierService.registerComponent(component);
  }

  public remove(component: IComponentBase) {
    this.notifierService.removeComponent(component);
  }

  protected registerImmediately(component: IComponentBase) {
    Promise.resolve().then(() => this.register(component));
  }

  ngOnDestroy(): void {
    this.remove(this);
  }
}
